<script src="../router.js"></script>
<template>
    <div class="full">
      <div class="bg-image"></div>
      <b-jumbotron header="Silk radio" lead="Made with ❤️ from XR">
        <b-container>
          <b-row>
            <b-col md="6" offset-md="3">
              <div class="player">
                <p>Now playing</p>
                <iframe
                        src="http://68.183.214.182/public/silk_radio/embed"
                        frameborder="0"
                        allowtransparency="true"
                        style="width: 100%; min-height: 150px; border: 0; color:white;"></iframe>
              </div>
            </b-col>        
          </b-row>
        </b-container>
      </b-jumbotron>
    </div>
</template>

<script>

export default {
  name: 'Home',
};
</script>

<style type="scss">
  .full {
    padding: 0 !important;
    margin: 0 auto !important;
    background-size: cover;
    overflow: hidden;
    height: 100%;
  }
  .jumbotron {
    background-color: transparent !important ;
  }
  h1 {
    font-family: "Impact";
  }
  .bg-image {
    position: absolute;
    background-size: cover;
    overflow: hidden;
    background-image: url("../assets/bg.jpg");
    height: 100%;
    width: 100%;
    /*background-size: 300%;
    background-position-y: -5%;
    filter: blur(1px);
    -webkit-filter: blur(3px);*/
    z-index: -1;
  }
  body.embed {
    .now-playing-title,
    .now-playing-artist{
      color: white;
    }
  }
  .player {
    background: rgb(0, 0, 0, 0.5);
    border-radius: 15px;
    padding: 5px 7px;
  }

</style>
